import React from 'react'
import dynamic from 'next/dynamic'
import { logger } from '@/utils/logging'
import { BitmovinPlayerProps, BitmovinUILoaderProps } from './types'

export const BitmovinUILoader = dynamic<BitmovinUILoaderProps>(
  () =>
    import('./BitmovinUILoader')
      .then((mod) => mod.BitmovinUILoader)
      .catch((err) => {
        logger().error('Failed to load the BitmovinUILoader!', err)
        throw err
      }),
  { ssr: false },
)

export const BitmovinPlayer = dynamic<BitmovinPlayerProps>(
  () =>
    import('./BitmovinPlayer')
      .then((mod) => mod.BitmovinPlayer as React.ComponentType<BitmovinPlayerProps>)
      .catch((err) => {
        logger().error('Failed to load the BitmovinPlayer!', err)
        throw err
      }),
  {
    ssr: false,
    loading: () => {
      return (
        <div className="aspect-h-9 aspect-w-16 bg-black lg:aspect-h-unset lg:aspect-w-unset lg:h-[60vh]">
          <div className="w-full bg-black" />
        </div>
      )
    },
  },
)
